<template>
	<div>
		<img class="ml-3 mt-3" src="/img/logo/grafias_medium_ondark.png" alt="xls" width="100px"/>
		<div class="page-error-404">
			<div class="container text-center">
				<img src="/img/404.png" alt="xls" width="500px"/>
				<div class="mt-4">{{$t('Snap! something is not right, no worries you did not break anything')}}, <a class="pointer underline" @click="goBack">{{$t('just go back')}} </a> {{$t('slowly')}}</div>
				<div>{{$t('If you reach this page by following a link, the session attached to the link might be expired')}}.</div>
			</div>
		</div>
	</div>
</template>

<script>

export default {
	name: 'Error404',
	components: {
	},
	data() {
		return {
		};
	},
	methods: {
		goBack() {
			window.history.back();
		},
	},
	computed: {
	},

};
</script>
